import { ContainerModule } from 'inversify';
import { DslRuntimeModule, DslRuntimeModuleSymbol } from '@xlearn/common';
import { QuizDslRuntimeModule } from './quiz-dsl-runtime-module'

export const quizDslModule = new ContainerModule((bind) => {
  bind<DslRuntimeModule>(DslRuntimeModuleSymbol).to(QuizDslRuntimeModule)
})
